import * as React from 'react'
const SvgComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={42} height={28} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.89 6.344V8.79l.855.978"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.025 8.056a5.136 5.136 0 1 1-10.272 0 5.136 5.136 0 0 1 10.272 0m12.839 4.28H27.73m5.99 9.414H38v-5.533a.86.86 0 0 0-.381-.712l-4.755-3.17-3.081-4.108a6.85 6.85 0 0 0-5.478-2.74h-1.712m3.424 16.264H14.889"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={2}
      d="M33.72 21.323a3.852 3.852 0 1 1-7.703 0 3.852 3.852 0 0 1 7.703 0Zm-18.83 0a3.852 3.852 0 1 1-7.704 0 3.852 3.852 0 0 1 7.703 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.186 21.75H5.474a1.71 1.71 0 0 1-1.712-1.711v-6.848l2.14-5.563-1.284-2.14h2.568"
    />
  </svg>
)
export default SvgComponent
